import { AxiosRequestConfig } from 'axios';
import { RecursivePartial } from '../../../..';
import { api } from '../../../api';
import { ApiResponse, PageResult } from '../../Utilities';
import { UserViewModel } from '../../ViewModels';
import { GetUsersParams } from './Params';

export class UserApi {
    private route = '/User';

    public getUsers = (
        params: GetUsersParams,
        requestConfig: AxiosRequestConfig = {}
    ): ApiResponse<PageResult<UserViewModel>> => {
        return api().get(this.route, { ...requestConfig, params });
    };

    public getUsersCSV = (params: {
        companyId?: number;
        $orderby?: string;
        $filter?: string;
        childCompanyId?: string;
        includeSubstituteUser?: boolean;
        portalType?: string;
    }): ApiResponse<string> => {
        return api().get(this.route, { params, headers: { Accept: 'text/csv' } });
    };

    public getUser = (userId: number): ApiResponse<UserViewModel[]> => {
        return api().get(`${this.route}/${userId}`);
    };

    /**
     * Used for sending invite to a supplier user.
     */
    public getUserForSendingRegistrationCode = (userId: number): ApiResponse<UserViewModel[]> => {
        return api().get(`${this.route}/${userId}`, { params: { sendRegistrationCode: true } });
    };

    public updateUser = (
        userId: number,
        user: RecursivePartial<UserViewModel>,
        sendRegistrationCode: boolean = false
    ): ApiResponse<UserViewModel> => {
        return api().put(`${this.route}/${userId}`, user, { params: { sendRegistrationCode } });
    };

    /**
     * Used for getting user profile from SSO token.
     */
    public getUserByToken = (): ApiResponse<UserViewModel> => {
        return api().get(`${this.route}/Token`);
    };
}
